import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useTranslation } from 'react-i18next';
import './App.css';
import nexusLogo from './assets/droitfacil.png';
import avatarAvocat from './assets/avocat.jpeg';
import avatarExpert from './assets/expert.jpeg';
import avatarProf from './assets/prof.jpeg';
import avatarMagistrat from './assets/magistrat.jpeg';
import avatarSaasa from './assets/saasa.jpeg';
import sponsorCc from './assets/cc.jpeg';
import sponsorAfri from './assets/afri.jpeg';
import sponsorKny from './assets/kny.jpeg';
import sponsorY from './assets/y.jpeg';
import sponsorSaasa from './assets/saasa.png';
import build from './assets/build.png';
import orangeLogo from './assets/orange.png';
import mtnLogo from './assets/mtn.jpg';
import cartebLogo from './assets/carteb.jpg';

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
    titleKey: 'features.carto_title',
    textKey: 'features.carto_text',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    titleKey: 'features.recruteur_title',
    textKey: 'features.recruteur_text',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <polyline points="8 21 12 17 16 21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
    titleKey: 'features.legaltools_title',
    textKey: 'features.legaltools_text',
  },
];

const sponsors = [
  {
    name: 'Cabinet CC Consulting',
    logo: sponsorCc,
  },
  {
    name: 'Africa First Finance',
    logo: sponsorAfri,
  },
  {
    name: 'KNY Group',
    logo: sponsorKny,
  },
  {
    name: 'Y-CONNEKT',
    logo: sponsorY,
  },
  {
    name: 'SAASA B2E',
    logo: sponsorSaasa,
  },
];

const speakers = [
  {
    nameKey: 'speakers.0.name',
    roleKey: 'speakers.0.role',
    textKey: 'speakers.0.text',
    avatar: avatarAvocat,
  },
  {
    nameKey: 'speakers.1.name',
    roleKey: 'speakers.1.role',
    textKey: 'speakers.1.text',
    avatar: avatarProf,
  },
  {
    nameKey: 'speakers.2.name',
    roleKey: 'speakers.2.role',
    textKey: 'speakers.2.text',
    avatar: avatarMagistrat,
    },
    {
      nameKey: 'speakers.3.name',
      roleKey: 'speakers.3.role',
      textKey: 'speakers.3.text',
      avatar: avatarExpert,
    },
    {
      nameKey: 'speakers.4.name',
      roleKey: 'speakers.4.role',
      textKey: 'speakers.4.text',
      avatar: avatarSaasa,
    },
];



const faqs = [
  {
    questionKey: 'faqs.0.question',
    answerKey: 'faqs.0.answer',
  },
  {
    questionKey: 'faqs.1.question',
    answerKey: 'faqs.1.answer',
  }
];

function App() {
  const { t, i18n } = useTranslation();
  const [showHeader, setShowHeader] = useState(true);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const agenda = [
    {
      time: t('agenda.0.time'),
      title: t('agenda.0.title'),
      type: t('agenda.0.type'),
      text: t('agenda.0.text'),
    },
    {
      time: t('agenda.1.time'),
      title: t('agenda.1.title'),
      type: t('agenda.1.type'),
      text: t('agenda.1.text'),
    },
    {
      time: t('agenda.2.time'),
      title: t('agenda.2.title'),
      type: t('agenda.2.type'),
      text: t('agenda.2.text'),
    },
    {
      time: t('agenda.3.time'),
      title: t('agenda.3.title'),
      type: t('agenda.3.type'),
      text: t('agenda.3.text'),
    },
    {
      time: t('agenda.4.time'),
      title: t('agenda.4.title'),
      type: t('agenda.4.type'),
      text: t('agenda.4.text'),
    }
  ];


  const refundPolicyItems = [
    {
      titleKey: t('refund.items.0.title'),
      textKey: t('refund.items.0.text'),
    },
    {
      titleKey: t('refund.items.1.title'),
      textKey: t('refund.items.1.text'),
    },
    {
      titleKey: t('refund.items.2.title'),
      textKey: t('refund.items.2.text'),
    },
    {
      titleKey: t('refund.items.3.title'),
      textKey: t('refund.items.3.text'),
    },
    {
      titleKey: t('refund.items.4.title'),
      textKey: t('refund.items.4.text'),
    },
  ];

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateHeaderVisibility = () => {
      const currentScrollY = window.scrollY;
      const nearTop = currentScrollY <= 24;
      const scrollingUp = currentScrollY < lastScrollY - 4;
      const scrollingDown = currentScrollY > lastScrollY + 4;

      if (nearTop || scrollingUp) {
        setShowHeader(true);
      } else if (scrollingDown && currentScrollY > 120) {
        setShowHeader(false);
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderVisibility);
        ticking = true;
      }
    };

    updateHeaderVisibility();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Ferme le menu mobile sur navigation ou resize
  useEffect(() => {
    const closeMenu = () => setIsMobileMenuOpen(false);
    if (isMobileMenuOpen) {
      window.addEventListener('resize', closeMenu);
    }
    return () => {
      window.removeEventListener('resize', closeMenu);
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsRefundModalOpen(false);
      }
    };

    if (isRefundModalOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isRefundModalOpen]);

  // États pour le formulaire d'inscription
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [typeUser, setTypeUser] = useState('etudiant');
  const [amount, setAmount] = useState(typeUser === 'etudiant' ? 3000 : 5000);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  // Pour le modal de soutien
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [supportFirstName, setSupportFirstName] = useState('');
  const [supportLastName, setSupportLastName] = useState('');
  const [supportPhone, setSupportPhone] = useState('');
  const [supportAmount, setSupportAmount] = useState('');
  const [supportLoading, setSupportLoading] = useState(false);
  const [supportError, setSupportError] = useState(null);

  // Met à jour le montant selon le statut
  useEffect(() => {
    setAmount(typeUser === 'etudiant' ? 3000 : 5000);
  }, [typeUser]);

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const response = await fetch('https://api.droitfacile.net/createTransaction.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName,
          lastName,
          email,
          phone: phone.startsWith('+') ? phone : `+${phone}`,
          description: `Inscription Forum Droit Facile - ${typeUser === 'etudiant' ? 'Étudiant' : 'Travailleur'}`,
          typeUser,
          amount,
        }),
      });
      const data = await response.json();
      console.log("Contenu de la réponse:", data);
      if (!data.success) {
        throw new Error(data.message || 'Une erreur est survenue lors de l\'inscription.');
      }
      if (data.payment_link) {
        window.location.href = data.payment_link;
      }
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <>
        <div className="aurora aurora-a" />
        <div className="aurora aurora-b" />

        <header className={`site-header ${showHeader ? 'is-visible' : 'is-hidden'}`}>
          <div className="brand-wrap">
            <img className="brand-logo" src={nexusLogo} alt="Logo Nexus Africa" />
            <span className="brand-name">Droit Facile</span>
          </div>
          <button
            className={`menu-toggle${isMobileMenuOpen ? ' is-active' : ''}`}
            aria-label="Ouvrir le menu"
            aria-expanded={isMobileMenuOpen}
            onClick={() => setIsMobileMenuOpen((v) => !v)}
          >
            <span className="menu-bar" />
            <span className="menu-bar" />
            <span className="menu-bar" />
          </button>

          <nav className={`main-nav${isMobileMenuOpen ? ' is-open' : ''}`} aria-label="Navigation principale">
            <a href="#apropos" onClick={() => setIsMobileMenuOpen(false)}>{t('nav_about')}</a>
            <a href="#panelistes" onClick={() => setIsMobileMenuOpen(false)}>{t('nav_speakers')}</a>
            <a href="#programme" onClick={() => setIsMobileMenuOpen(false)}>{t('nav_agenda')}</a>
            <a href="#faq" onClick={() => setIsMobileMenuOpen(false)}>{t('nav_faq')}</a>
            <div className="header-cta">
              <button
                type="button"
                className="ghost-btn"
                onClick={() => i18n.changeLanguage(i18n.language === 'fr' ? 'en' : 'fr')}
              >
                {i18n.language === 'fr' ? 'English' : 'Français'}
              </button>
            </div>
          </nav>
        </header>

        <main>
          <section id="apropos" className="hero-section card-panel reveal-up">
            <div className="hero-copy">
              <p className="pill">{t('edition')}</p>
              <h1>
                {t('hero_title1')}
                <span>{t('hero_title2')}</span>
                {t('hero_title3')}
              </h1>
              <p className="hero-text">
                {t('hero_text')}
              </p>

              <div className="hero-actions">
                <a href="#inscription" className="solid-btn">
                  {t('reserve')}
                </a>
                <button type="button" className="outline-btn" onClick={() => setIsSupportModalOpen(true)}>
                  {t('support_project')}
                </button>
                {/* Modal Soutenir le projet */}
                {isSupportModalOpen && (
                  <div className="modal-overlay" onClick={() => setIsSupportModalOpen(false)} role="presentation" style={{ zIndex: 1000 }}>
                    <section className="policy-modal card-panel" role="dialog" aria-modal="true" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
                      <div className="policy-modal-header">
                        <h2 style={{ marginBottom: 0 }}>{t('support_project')}</h2>
                        <button type="button" className="modal-close-btn" aria-label="Fermer" onClick={() => setIsSupportModalOpen(false)}>×</button>
                      </div>
                      <form
                        className="form-grid"
                        style={{ marginTop: '1.2rem' }}
                        onSubmit={async e => {
                          e.preventDefault();
                          setSupportLoading(true);
                          setSupportError(null);
                          try {
                            const response = await fetch('https://api.droitfacile.net/createTransaction.php', {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: JSON.stringify({
                                firstName: supportFirstName,
                                lastName: supportLastName,
                                phone: supportPhone,
                                description: 'Soutien au projet Droit Facile',
                                typeUser: 'soutien',
                                amount: supportAmount,
                              }),
                            });
                            const data = await response.json();
                            if (!data.success) throw new Error(data.message || 'Erreur lors de la création du paiement.');
                            if (data.payment_link) {
                              window.location.href = data.payment_link;
                            }
                          } catch (err) {
                            setSupportError(err.message);
                          } finally {
                            setSupportLoading(false);
                          }
                        }}
                      >
                        <div>
                          <label>{t('prenom')}</label>
                          <input value={supportFirstName} onChange={e => setSupportFirstName(e.target.value)} required />
                        </div>
                        <div>
                          <label>{t('nom')}</label>
                          <input value={supportLastName} onChange={e => setSupportLastName(e.target.value)} required />
                        </div>
                        <div className="full-col">
                          <label>{t('whatsapp')}</label>
                          <PhoneInput
                            country={'cm'}
                            value={supportPhone}
                            onChange={setSupportPhone}
                            inputProps={{ required: true, name: 'supportPhone' }}
                            enableSearch
                          />
                        </div>
                        <div className="full-col">
                          <label>{t('montant')}</label>
                          <input value={supportAmount} onChange={e => setSupportAmount(e.target.value)} required />
                        </div>
                        <div className="full-col">
                          <button type="submit" className="solid-btn full-btn" disabled={supportLoading}>
                            {supportLoading ? t('chargement') : 'Soutenir'}
                          </button>
                        </div>
                        {supportError && <div className="form-error">{supportError}</div>}
                      </form>
                    </section>
                  </div>
                )}
              </div>

              <p className="event-meta">{t('event_meta')}</p>
            </div>

            <div className="hero-visual">
              <img
                src={build}
                alt="Tour moderne"
              />
              <div className="overlay-card">
                <p>Droit Facile</p>
                <strong>Vers le Droit 2.0</strong>
                <div className="avatars" aria-hidden="true">
                  <img src={avatarAvocat} alt="Avocat" className="hero-avatar" />
                  <img src={avatarProf} alt="Professeur" className="hero-avatar" />
                  <img src={avatarMagistrat} alt="Magistrat" className="hero-avatar" />
                </div>
              </div>
            </div>
          </section>

          <section className="feature-grid reveal-up">
            {features.map((item, idx) => (
              <article className="feature-card card-panel" key={item.titleKey}>
                <span className="feature-icon">{item.icon}</span>
                <h3>{t(item.titleKey)}</h3>
                <p>{t(item.textKey)}</p>
              </article>
            ))}
          </section>

          <section id="panelistes" className="reveal-up">
            <div className="section-heading">
              <h2>{t('panelistes_title')}</h2>
              <p>{t('panelistes_text')}</p>
            </div>

            <div className="speaker-grid">
              {speakers.map((speaker) => (
                <article key={speaker.nameKey} className="speaker-card card-panel">
                  <img src={speaker.avatar} alt={t(speaker.nameKey)} />
                  <h3>{t(speaker.nameKey)}</h3>
                  <p className="speaker-role">{t(speaker.roleKey)}</p>
                  <p>{t(speaker.textKey)}</p>
                </article>
              ))}
            </div>
          </section>

          <section id="inscription" className="register-wrap card-panel reveal-up">
            <div className="register-main">
              <h2>{t('inscription_title')}</h2>

              <form className="form-grid" aria-label={t('inscription_title')} onSubmit={handleSubmit}>
                <div>
                  <label>{t('prenom')}</label>
                  <input value={firstName} onChange={e => setFirstName(e.target.value)} required />
                </div>
                <div>
                  <label>{t('nom')}</label>
                  <input value={lastName} onChange={e => setLastName(e.target.value)} required />
                </div>
                <div className="full-col">
                  <label>{t('email')}</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
                </div>
                <div>
                  <label>{t('whatsapp')}</label>
                  <PhoneInput
                    country={'cm'}
                    value={phone}
                    onChange={setPhone}
                    inputProps={{ name: 'phone' }}
                    enableSearch
                  />
                </div>
                <div>
                  <label>{t('statut')}</label>
                  <select value={typeUser} onChange={e => setTypeUser(e.target.value)}>
                    <option value="etudiant">{t('statut_etudiant')}</option>
                    <option value="travailleur">{t('statut_travailleur')}</option>
                  </select>
                </div>
                <div className="full-col">
                  <label>{t('montant')}</label>
                  <input value={amount} readOnly />
                </div>
                <div className="full-col">
                  <button type="submit" className="solid-btn full-btn" disabled={loading}>
                    {loading ? t('chargement') : t('confirmer')}
                  </button>
                </div>
                {error && <div className="form-error">{error}</div>}
                {success && <div className="form-success">{t('inscription_success')}</div>}
              </form>

              <p className="register-disclaimer">
                {t('register_disclaimer')} <a href="#footer_refundPolicy"
                  onClick={() => setIsRefundModalOpen(true)}>{t('footer_refundPolicy')}</a>
              </p>
            </div>

            <aside className="payment-side">
              <h3>{t('modes_paiement')}</h3>
              <div className="pay-card active">
                <span><img src={orangeLogo} alt="Orange Money" style={{ height: 32, width: 32, objectFit: 'contain' }} /></span>
                <div>
                  <strong>{t('pay_om')}</strong>
                  {/* <p>{t('pay_om_desc')}</p> */}
                </div>
              </div>
              <div className="pay-card">
                <span><img src={mtnLogo} alt="MTN Mobile Money" style={{ height: 32, width: 32, objectFit: 'contain' }} /></span>
                <div>
                  <strong>{t('pay_mtn')}</strong>
                  {/* <p>{t('pay_mtn_desc')}</p> */}
                </div>
              </div>
              <div className="pay-card">
                <span><img src={cartebLogo} alt="Carte Bancaire" style={{ height: 32, width: 32, objectFit: 'contain' }} /></span>
                <div>
                  <strong>{t('pay_cb')}</strong>
                  {/* <p>{t('pay_cb_desc')}</p> */}
                </div>
              </div>

              {/* Bloc don à adapter si besoin */}
            </aside>
          </section>

          <section id="programme" className="reveal-up">
            <div className="section-heading left">
              <h2>{t('programme_title')}</h2>
              <p>{t('programme_text')}</p>
            </div>

            <div className="timeline">
              {agenda.length === 0 ? (
                <p className="agenda-empty">Programme pas encore disponible.</p>
              ) : (
                agenda.map((slot) => (
                  <article className="timeline-item card-panel" key={slot.title}>
                    <span className="slot-time">{slot.time}</span>
                    <div>
                      <h3>{slot.title}</h3>
                      <small>{slot.type}</small>
                      <p>{slot.text}</p>
                    </div>
                  </article>
                ))
              )}
            </div>
          </section>

          <section id="faq" className="faq card-panel reveal-up">
            <div className="section-heading">
              <h2>{t('faq_title')}</h2>
              <p>{t('faq_text')}</p>
            </div>

            <div className="faq-list">
              {faqs.map((item, index) => (
                <details key={item.questionKey} open={index === 0}>
                  <summary>{t(item.questionKey)}</summary>
                  <p>{t(item.answerKey)}</p>
                </details>
              ))}
            </div>
          </section>

          <section className="partners reveal-up">
            <p>{t('partners_title')}</p>
            <div>
              {sponsors.map((sponsor) => (
                <article className="partner-card" key={sponsor.name}>
                  <img src={sponsor.logo} alt={sponsor.name} />
                  <span className="partner-name">{sponsor.name}</span>
                </article>
              ))}
            </div>
          </section>
        </main>

        <footer className="site-footer card-panel">
          <div>
            <h3>{t('footer_title')}</h3>
            <p>{t('footer_text')}</p>
          </div>
          <div>
            <h4>{t('footer_nav')}</h4>
            <a href="#apropos">{t('nav_about')}</a>
            <a href="#programme">{t('nav_agenda')}</a>
            <a href="#faq">{t('nav_faq')}</a>
          </div>
          <div>
            <h4>{t('footer_support')}</h4>
            <button
              type="button"
              className="footer-link-button"
              onClick={() => setIsRefundModalOpen(true)}
            >
              {t('footer_conditions')}
            </button>
            <a href="https://chat.whatsapp.com/CoPwy612xIc4wKPvreTjPg?mode=gi_t" target='_blank'>{t('footer_contact')}</a>
          </div>
        </footer>

        {isRefundModalOpen ? (
          <div
            className="modal-overlay"
            onClick={() => setIsRefundModalOpen(false)}
            role="presentation"
          >
            <section
              className="policy-modal card-panel"
              role="dialog"
              aria-modal="true"
              aria-labelledby="refund-policy-title"
              onClick={(event) => event.stopPropagation()}
            >
              <div className="policy-modal-header">
                <div>
                  <p className="policy-modal-kicker">{t('refund.kicker')}</p>
                  <h2 id="refund-policy-title">{t('refund.title')}</h2>
                </div>
                <button
                  type="button"
                  className="modal-close-btn"
                  aria-label={t('refund.closeAria')}
                  onClick={() => setIsRefundModalOpen(false)}
                >
                  ×
                </button>
              </div>

              <p className="policy-modal-intro">
                {t('refund.intro')}
              </p>
              <div className="policy-modal-body">
                {refundPolicyItems.map((item) => (
                  <article key={item.titleKey} className="policy-point">
                    <h3>{item.titleKey}</h3>
                    <p>{item.textKey}</p>
                  </article>
                ))}
              </div>

              <div className="policy-modal-footer">
                <p>
                  {t('refund.footer')}
                </p>
                <button
                  type="button"
                  className="solid-btn"
                  onClick={() => setIsRefundModalOpen(false)}
                >
                  {t('refund.ok')}
                </button>
              </div>
            </section>
          </div>
        ) : null}
      </>
    </div >
  );
}

export default App;
